import industrialDomesticImg from "../components/repair/wiring.jpg";
import wiringImg from "../components/repair/one.jpg";
import faultsImg from "../components/repair/four.jpg";
import appliancesImg from "../components/repair/tools.jpg";
import maintenanceImg from "../components/repair/three.jpg";
import pumpsImg from "../components/plumbing/plumber1.jpg";
import generatorsImg from "../components/repair/three.jpg";



export const servicesData = [
    {
        id: 1,
        imgSrc: industrialDomesticImg,
        heading: "Industrial Commercial Domestic",
        description: "Professional wiring services for residential and commercial properties.",    
        eachServiceDescription: "Industrial, commercial, and domestic clients rely on KM Electrical Construction Company for their diverse electrical needs. With expertise in each sector, KM Electrical delivers tailored solutions, ensuring efficient and safe electrical systems that meet industry standards and client specifications.",
        eachServiceHeading: "Professional Wiring Services",
        dataList: [
            "Inspect wiring requirements.",
            "Plan wiring layout.",
            "Install wiring system.",
            "Test and troubleshoot wiring issues."
        ]
    },
    {
        id: 2,
        imgSrc: faultsImg,
        heading: "Faults",
        description: "Expert circuit installation and troubleshooting.",
        eachServiceDescription: "When faults occur in electrical systems, KM Electrical swiftly identifies and rectifies issues, minimizing downtime and ensuring uninterrupted operations for businesses and households alike.",
        eachServiceHeading: "Circuit Installation & Troubleshooting",
        dataList: [
            "Identify circuit faults.",
            "Repair or replace faulty components.",
            "Test circuits for proper functioning."
        ]
    },
    {
        id: 3,
        imgSrc: maintenanceImg,
        heading: "Maintenance",
        description: "Routine maintenance for electrical systems in homes and businesses.",
        eachServiceDescription: "Regular maintenance is crucial for prolonging the lifespan and performance of electrical systems. KM Electrical offers comprehensive maintenance services, including inspections, testing, and preventive measures, to keep systems running smoothly and avoid costly breakdowns.",
        eachServiceHeading: "Routine Maintenance",
        dataList: [
            "Inspect electrical systems.",
            "Clean and lubricate components.",
            "Replace worn-out parts.",
            "Test system functionality."
        ]
    },
    {
        id: 4,
        imgSrc: generatorsImg,
        heading: "Generators",
        description: "Installation and maintenance of backup power generators.",
        eachServiceDescription: "KM Electrical provides expert installation, maintenance, and repair services for generators, offering reliable backup power solutions for industrial, commercial, and residential properties.",
        eachServiceHeading: "Generator Installation & Maintenance",
        dataList: [
            "Select appropriate generator size.",
            "Install generator according to manufacturer guidelines.",
            "Regular maintenance checks.",
            "Repair or replace faulty parts."
        ]
    },
    {
        id: 5,
        imgSrc: appliancesImg,
        heading: "Appliances",
        description: "Installation and repair of electrical appliances.",
        eachServiceDescription: "From installation to repair, KM Electrical handles a wide range of appliances, ensuring they operate safely and efficiently, whether in a commercial kitchen, industrial facility, or household setting.",
        eachServiceHeading: "Appliance Installation & Repair",
        dataList: [
            "Install new appliances.",
            "Repair or replace malfunctioning appliances.",
            "Test appliances for proper functioning."
        ]
    },
    {
        id: 6,
        imgSrc: industrialDomesticImg,
        heading: "Compliance Testing",
        description: "Testing electrical systems to ensure compliance with safety regulations.",
        eachServiceDescription: "Compliance testing is essential to ensure electrical systems meet regulatory requirements and safety standards. KM Electrical conducts thorough testing and certification, providing peace of mind to clients and ensuring compliance with legal obligations.",
        eachServiceHeading: "Compliance Testing",
        dataList: [
            "Conduct safety inspections.",
            "Test electrical components for compliance.",
            "Document test results."
        ]
    },
    {
        id: 7,
        imgSrc: industrialDomesticImg,
        heading: "HV Equipments",
        description: "Installation and maintenance of high-voltage electrical equipment.",
        eachServiceDescription: "HV (High Voltage) equipment requires specialized handling and maintenance to ensure safety and reliability. KM Electrical offers expert services for HV equipment, including installation, testing, and maintenance, adhering to strict safety protocols.",
        eachServiceHeading: "High-Voltage Equipment Services",
        dataList: [
            "Install high-voltage equipment.",
            "Perform regular maintenance checks.",
            "Troubleshoot and repair faults."
        ]
    },
    {
        id: 8,
        imgSrc: industrialDomesticImg,
        heading: "Process Leads",
        description: "Installation of electrical leads for industrial processes.",
        eachServiceDescription: "KM Electrical manages the entire leads process, from design to installation, ensuring efficient power distribution and optimal performance for industrial and commercial clients.",
        eachServiceHeading: "Process Lead Installation",
        dataList: [
            "Assess electrical requirements for industrial processes.",
            "Install leads according to specifications.",
            "Test leads for proper connectivity."
        ]
    },
    {
        id: 9,
        imgSrc: wiringImg,
        heading: "Lines Control Wiring",
        description: "Wiring services for control systems in industrial settings.",
        eachServiceDescription: "Line control wiring is crucial for the operation of various systems and equipment. KM Electrical provides expert wiring services, ensuring precise control and reliable operation of electrical systems in industrial, commercial, and domestic settings.",
        eachServiceHeading: "Control Wiring Services",
        dataList: [
            "Design wiring layout for control systems.",
            "Install wiring according to control system requirements.",
            "Test wiring for proper functionality."
        ]
    },
    {
        id: 10,
        imgSrc: industrialDomesticImg,
        heading: "Switch Boards",
        description: "Installation and repair of electrical switchboards.",
        eachServiceDescription: "Switchboards are the backbone of electrical distribution systems. KM Electrical offers comprehensive services for switchboards, including installation, maintenance, and repair, ensuring efficient power distribution and safety.",
        eachServiceHeading: "Switchboard Installation & Repair",
        dataList: [
            "Install switchboards.",
            "Replace faulty components.",
            "Test switchboards for proper operation."
        ]
    },
    {
        id: 11,
        imgSrc: pumpsImg,
        heading: "Pumps",
        description: "Installation and maintenance of electrical pumps.",
        eachServiceDescription: "Pumps play a vital role in many industrial processes and domestic water systems. KM Electrical provides expert pump services, including installation, maintenance, and repair, to ensure reliable operation and minimize downtime.",
        eachServiceHeading: "Pump Installation & Maintenance",
        dataList: [
            "Select appropriate pump type.",
            "Install pumps according to specifications.",
            "Regular maintenance checks.",
            "Repair or replace faulty pumps."
        ]
    },
    {
        id: 12,
        imgSrc: industrialDomesticImg,
        heading: "Lighting",
        description: "Installation and repair of lighting systems for homes and businesses.",
        eachServiceDescription: "Lighting is essential for safety, productivity, and ambiance in any environment. KM Electrical offers professional lighting solutions, including installation, retrofitting, and maintenance, to enhance illumination and energy efficiency for industrial, commercial, and domestic clients.",
        eachServiceHeading: "Lighting Installation & Repair",
        dataList: [
            "Install lighting fixtures.",
            "Replace bulbs and other components.",
            "Test lighting for proper brightness and functionality."
        ]
    },
];
